/* eslint-disable sort-keys-fix/sort-keys-fix */
const PriceTypes = {
    TIER: "tier",
    UNIT: "unit",
    LICENSE: "license",
};

export default PriceTypes;
